import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService, public toasterService: ToastrService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      if (!this.authService.isAdmin && !route.data.forAdmin) {
        return true;
      } else if (this.authService.isAdmin) {
        return true;
      } else {
        this.toasterService.error(
          'No tiene permisos para acceder a la ruta seleccionada',
          'Error',
          {
              positionClass: 'toast-bottom-right',
              progressAnimation: 'decreasing',
              progressBar: true
          });
        this.router.navigate(['/login'], { queryParams: { redirect: state.url }, replaceUrl: true });
        return false;
      }
    }
    this.router.navigate(['/login'], { queryParams: { redirect: state.url }, replaceUrl: true });
    return false;
  }

}
